// extracted by mini-css-extract-plugin
export var messageSideLeft = "_oo-1";
export var messageSideRight = "_oo-2";
export var subscribeToBackInStockBubbleContainer = "_oo-0";